import React from 'react';
import Svg, { Path, Text as SvgText } from 'react-native-svg';
import { Props } from '../../assets/SvgProps';
import { useScreenTheme } from '../../hooks/useScreenTheme';
import Typography from '../../constants/Typography';

const LeaderFourIcon = ({
  bgColor = '#FFF085',
  borderColor = '#FEFCE8',
  text = '',
}: Props) => {
  const { LeaderRemainingColorText } = useScreenTheme('DashboardScreen');
  return (
    <Svg width="48" height="48" viewBox="0 0 48 48" fill="none">
      <Path
        d="M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z"
        fill={bgColor}
      />
      <Path
        d="M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z"
        stroke={borderColor}
      />
      <SvgText
        x="21"
        y="24"
        fontSize={Typography.fontSize.fontSize16}
        fontWeight={Typography.fontWeight.medium}
        fontFamily={Typography.fontFamily.inter}
        fill={LeaderRemainingColorText}
        textAnchor="middle"
        alignmentBaseline="middle"
      >
        #{text}
      </SvgText>
    </Svg>
  );
};

export default LeaderFourIcon;
